import React from 'react';
import { motion } from 'framer-motion';
import { QrCode, ArrowRight } from 'lucide-react';
interface LeadAuditSlideProps {
  content: {
    headline: string;
    bullets: string[];
    callToAction: string;
  };
}
export function LeadAuditSlide({
  content
}: LeadAuditSlideProps) {
  return <div className="bg-[#1C1C1C] rounded-2xl p-16 min-h-[600px] flex items-center" data-id="element-145">
      <div className="w-3/5 pr-12" data-id="element-146">
        <motion.h2 initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} className="text-5xl font-bold text-white mb-12 leading-tight" data-id="element-147">
          {content.headline}
        </motion.h2>

        <div className="space-y-6 mb-12" data-id="element-148">
          {content.bullets.map((bullet, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + index * 0.1
        }} className="flex items-start gap-4" data-id="element-149">
              <ArrowRight className="text-[#0FB07D] w-6 h-6 flex-shrink-0 mt-1" data-id="element-150" />
              <p className="text-xl text-[#F5F5F5]/90 leading-relaxed" data-id="element-151">
                {bullet}
              </p>
            </motion.div>)}
        </div>
      </div>

      <div className="w-2/5 flex flex-col items-center justify-center" data-id="element-152">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.5,
        type: 'spring'
      }} className="bg-white p-8 rounded-3xl shadow-2xl flex flex-col items-center border-4 border-[#0FB07D]" data-id="element-153">
          <div className="w-64 h-64 rounded-xl overflow-hidden mb-6" data-id="element-154">
            <img src="https://cdn.magicpatterns.com/uploads/hMzsU8nP9rQ5yvUKMqzy78/Consultation_QR.png" alt="Scan to book a free consultation" className="w-full h-full object-contain" data-id="element-155" />
          </div>
          <p className="text-center text-[#1C1C1C] font-bold text-lg max-w-[250px]" data-id="element-156">
            {content.callToAction}
          </p>
        </motion.div>
      </div>
    </div>;
}
export default LeadAuditSlide;